import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Disable react-error-overlay in Cypress
if (window.Cypress) {
  // @ts-ignore
  window.addEventListener('error', event => {
    // @ts-ignore
    if (event.message.includes('ResizeObserver loop limit exceeded')) {
      // This is a common benign error in Cypress, ignore it
      return;
    }
    // Prevent the default error handling (which shows the overlay)
    event.stopImmediatePropagation();
  });

  // @ts-ignore
  window.addEventListener('unhandledrejection', event => {
    // Prevent the default error handling (which shows the overlay)
    event.stopImmediatePropagation();
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
